import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, tap, retry, switchMap, mergeMap } from 'rxjs/operators';

import { NgxPermissionsService } from 'ngx-permissions';
import { DataAccessPermissionsService } from '@unico-people/shared/dashboard/data-access-permissions';

import * as permissionActions from '../actions/permissions.action';

@Injectable()
export class PermissionsEffects {
  constructor(
    private actions$: Actions,
    private permissionsService: DataAccessPermissionsService,
    private permService: NgxPermissionsService,
    private route: ActivatedRoute
  ) {}

  @Effect()
  accountsPermissions$ = this.actions$.pipe(
    ofType(permissionActions.loadAccountsPermissions),
    mergeMap(res => {
      return this.permissionsService.getAccountsPermissions(res?.payload).pipe(
        map(permission => permissionActions.loadAccountsPermissionsSuccess({ payload: permission })),
        retry(1),
        catchError(error => {
          return of(permissionActions.loadAccountsPermissionsFail({ payload: error }));
        })
      );
    })
  );

  @Effect()
  unitsPermissions$ = this.actions$.pipe(
    ofType(permissionActions.loadUnitsPermissions),
    switchMap(res => {
      return this.permissionsService.getUnitsPermissions(res?.payload).pipe(
        map(permission => permissionActions.loadUnitsPermissionsSuccess({ payload: permission })),
        retry(2),
        catchError(error => {
          return of(permissionActions.loadUnitsPermissionsFail({ payload: error }));
        })
      );
    })
  );

  callbackAccountsPermissions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(permissionActions.loadAccountsPermissionsSuccess),
        tap(value => {
          const permissions = value?.payload;
          Object.keys(permissions).forEach(key => {
            this.permService.loadPermissions(permissions[key]);
          });
        })
      ),
    { dispatch: false }
  );

  callbackUnitsPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(permissionActions.loadUnitsPermissionsSuccess),
      tap(value => {
        const permissions: any = value?.payload;
        let unit: string;
        this.route.queryParams.subscribe(params => {
          unit = params.u;
        });

        Object.keys(permissions).forEach(key => {
          if (key === `unit:${unit}`) {
            this.permService.loadPermissions(permissions[key]);
          }
        });
      })
    )
  );
}
